export class GetYuipotaManualResponse {
  yuipotaInitialRegistrationManualPdfUrl!: string
  yuipotaInitialRegistrationManualPdfDownloadUrl!: string
  yuipotaUserGuidePdfUrl!: string
  yuipotaUserGuidePdfDownloadUrl!: string
  yuipotaChangeEmailAddressManualPdfUrl!: string
  yuipotaChangeEmailAddressManualPdfDownloadUrl!: string
}
